import { createContext, useContext, useEffect, useState } from "react";
import WebsocketService, { ConnectionState } from "../services/WebsocketService";

export const WebsocketContext = createContext<WebsocketService | null>(null)

export const useWebsocket = () => {
    const ctx = useContext(WebsocketContext)

    if(!ctx) {
        throw new Error("Websocket not provided!")
    }
    return ctx
}

export const useSocketStatus = () => {
    const [status, setStatus] = useState<ConnectionState>('idle')
    const socket = useWebsocket()

    useEffect(() => {
       return socket.subscribeState(setStatus)
    }, [socket])

    return status
}